import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const SDGSection: React.FC = () => {
  const sdgs = [
    {
      title: 'Zero Hunger',
      number: 2,
      icon: 'fas fa-utensils',
      color: '#f4a261',
    },
    {
      title: 'Clean Water and Sanitation',
      number: 6,
      icon: 'fas fa-tint',
      color: '#e76f51',
    },
    {
      title: 'Affordable and Clean Energy',
      number: 7,
      icon: 'fas fa-bolt',
      color: '#2a9d8f',
    },
    {
      title: 'Sustainable Cities and Communities',
      number: 11,
      icon: 'fas fa-city',
      color: '#e9c46a',
    },
    {
      title: 'Climate Action',
      number: 13,
      icon: 'fas fa-globe-americas',
      color: '#264653',
    },
  ];

  return (
    <section className="sdg-section py-5">
      <Container>
        <h2 className="text-center mb-5 sdg-title">Contributing to Global Sustainability Goals</h2>
        <Row className="justify-content-center">
          {sdgs.map((sdg, index) => (
            <Col xs={6} sm={4} md={2} key={index} className="mb-4 d-flex justify-content-center">
              <div className="sdg-box text-center" style={{ backgroundColor: sdg.color }}>
                <i className={`${sdg.icon} sdg-icon`}></i>
                <p className="sdg-text">{sdg.title}</p>
                {/* <p className="sdg-number">#{sdg.number}</p> */}
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default SDGSection;